export const supportedProfileLocaleCodes = ["en-US", "en-GB"] as const;

export type SupportedProfileLocaleCode = (typeof supportedProfileLocaleCodes)[number];

export const supportedProfileLocales: readonly {
  readonly code: SupportedProfileLocaleCode;
  readonly label: string;
}[] = [
  { code: "en-US", label: "English (United States)" },
  { code: "en-GB", label: "English (United Kingdom)" },
];

export function defaultProfileLocale(
  browserLanguage: string | undefined,
): SupportedProfileLocaleCode {
  return browserLanguage?.trim().toLowerCase() === "en-gb" ? "en-GB" : "en-US";
}
